import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface ActiveClassesWeekComparisonResponse {
  currentWeek: number;
  previousWeek: number;
  delta: number;
  percentageChange: number;
  changeType: 'increase' | 'decrease' | 'no-change';
}

export interface GetActiveClassesWeekComparisonParams {
  sessionId: string;
}

export const getActiveClassesWeekComparisonAPI = async ({
  sessionId,
}: GetActiveClassesWeekComparisonParams) => {
  const response = await baseAPI.get<ActiveClassesWeekComparisonResponse>(
    '/dashboard/metrics/active-classes/week-comparison',
    { params: { sessionId } },
  );
  return response.data;
};

export const useGetActiveClassesWeekComparison = (
  params: GetActiveClassesWeekComparisonParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.ACTIVE_CLASSES_WEEK_COMPARISON, params.sessionId],
    queryFn: () => getActiveClassesWeekComparisonAPI(params),
    enabled: !!params.sessionId,
  });
};
